import React, { useState } from 'react';
import {
  Box,
  Button,
  InputAdornment,
  Menu,
  MenuItem,
  TextField,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { colors } from '../../styles/theme';
import { CAD_SORT_OPTIONS } from '../data/cadConstants';
import {
  showroomCompactMenuButtonSx,
  showroomCountsRowSx,
  showroomMenuItemSx,
  showroomMenuPaperSx,
} from '../Showroom.styles';
import StockStatusFilter from '../../Map/components/StockStatusFilter';
import {
  listSearchFieldSx,
  listSearchIconSx,
} from '../../Map/components/UserLotListsPanel/UserLotListsPanel.styles';

function CompactMenuButton({ label, value, onClick, 'aria-label': ariaLabel }) {
  return (
    <Button
      size="small"
      onClick={onClick}
      endIcon={<ExpandMoreIcon sx={{ fontSize: '16px !important' }} />}
      aria-label={ariaLabel}
      sx={showroomCompactMenuButtonSx}
    >
      {label}
      {' '}
      <Box
        component="span"
        sx={{ color: colors.textPanelTitle, fontWeight: 500, ml: 0.5 }}
      >
        {value}
      </Box>
    </Button>
  );
}

/**
 * Estado es multi-selección: el buscador puede devolver más de uno
 * (“disponibles o en oferta”) y el chip tiene que poder representarlo.
 */
export default function ShowroomManageFilters({
  searchQuery = '',
  onSearchChange,
  statusFilter = null,
  onStatusChange,
  featuresCount,
  counts,
  sortBy,
  onSortChange,
  showStatusFilter = true,
  sortOptions = CAD_SORT_OPTIONS,
}) {
  const [sortMenuAnchor, setSortMenuAnchor] = useState(null);
  const options = Array.isArray(sortOptions) && sortOptions.length ? sortOptions : CAD_SORT_OPTIONS;
  const sortLabel = options.find((option) => option.value === sortBy)?.label || 'Nombre';

  return (
    <>
      {onSearchChange ? (
        <TextField
          size="small"
          fullWidth
          placeholder="Buscar por nombre o descripción"
          value={searchQuery}
          onChange={(event) => onSearchChange(event.target.value)}
          sx={{ ...listSearchFieldSx, mt: 0 }}
          inputProps={{ maxLength: 80 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={listSearchIconSx} />
              </InputAdornment>
            ),
          }}
        />
      ) : null}

      <Box sx={showroomCountsRowSx}>
        {showStatusFilter ? (
          <StockStatusFilter
            value={statusFilter}
            onChange={onStatusChange}
            counts={counts}
            totalCount={featuresCount}
          />
        ) : <Box />}
        <CompactMenuButton
          label="Ordenar por:"
          value={sortLabel}
          aria-label="Ordenar lotes"
          onClick={(event) => setSortMenuAnchor(event.currentTarget)}
        />
        <Menu
          anchorEl={sortMenuAnchor}
          open={Boolean(sortMenuAnchor)}
          onClose={() => setSortMenuAnchor(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{ sx: showroomMenuPaperSx }}
        >
          {options.map((option) => (
            <MenuItem
              key={option.value}
              selected={sortBy === option.value}
              onClick={() => {
                onSortChange(option.value);
                setSortMenuAnchor(null);
              }}
              sx={showroomMenuItemSx}
            >
              {option.label}
            </MenuItem>
          ))}
        </Menu>
      </Box>
    </>
  );
}
